import {
  MetacomConnectionResponse,
  MetacomDataResponse,
  MetacomMomentResponse,
} from "@core/models/api.response";
import { MetacomDataDTO } from "@core/models/dto.models";

import { createActionGroup, emptyProps, props } from "@ngrx/store";

export const metacomActions = createActionGroup({
  source: "metacom",
  events: {
    "Set Metacom Details": props<MetacomDataDTO>(),
    "Set Metacom Details Success": props<MetacomDataResponse>(),
    "Set Metacom Details Failed": props<MetacomDataResponse>(),
    "Request Metacom Connection": emptyProps(),
    "Request Metacom Connection Success": props<MetacomConnectionResponse>(),
    "Request Metacom Connection Failed": props<MetacomConnectionResponse>(),
    "Request Metacom Moment": emptyProps(),
    "Request Metacom Moment Success": props<MetacomMomentResponse>(),
    "Request Metacom Moment Failed": props<MetacomMomentResponse>(),
    "Reset Metacom Statuses": emptyProps(),
  },
});
